import { useAppStore } from '@/stores/appStore';
import { useEffect } from 'react';

export const useTheme = () => {
  const { theme, setTheme, toggleTheme } = useAppStore();

  useEffect(() => {
    // Apply theme to document on mount
    if (theme.mode === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme.mode]);

  return {
    theme,
    setTheme,
    toggleTheme,
    isDark: theme.mode === 'dark',
    isLight: theme.mode === 'light',
  };
};
